import { useEffect, useCallback } from 'react'

type OptionalConfig = Pick<
  KeyboardEvent,
  'altKey' | 'ctrlKey' | 'shiftKey' | 'metaKey'
>

interface ShortcutConfig extends Partial<OptionalConfig> {
  code: KeyboardEvent['code']
  shortcutTarget?: HTMLElement
}

type ShortcutAction = (e: KeyboardEvent) => void

export default function useKeyboardShortcut(
  shortcutAction: ShortcutAction,
  config: ShortcutConfig,
) {
  const targetElement = config.shortcutTarget || document

  const eventHandler = useCallback(
    (e: KeyboardEvent) => {
      const { code, ctrlKey, altKey, shiftKey, metaKey } = e
      if (config.code !== code) return
      if (config.shiftKey && !shiftKey) return
      if (config.metaKey && !(metaKey || ctrlKey)) return
      if (config.ctrlKey && !(metaKey || ctrlKey)) return
      if (config.altKey && !altKey) return

      shortcutAction(e)
    },
    [shortcutAction, config],
  )

  useEffect(() => {
    ;(targetElement as Document).addEventListener('keydown', eventHandler)
    return () =>
      (targetElement as Document).removeEventListener('keydown', eventHandler)
  }, [targetElement, eventHandler])
}
